export enum ListColumnField {
  Title = "title",
  Owner = "owner",
  AddressLine1 = "address_line_1",
  Zip = "zip",
  City = "city",
  Phone = "phone",
  Fax = "fax",
  Website = "website",
}
